<template>
  <div class="charts-page">
    <div class="va-row">
      <div class="flex md6 xs12">
        <vuestic-widget class="chart-widget" :headerText="$t('charts.verticalBarChart')">
          <vuestic-chart :data="verticalBarChartData" type="vertical-bar" />
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import VerticalBarChartData from "../../data/charts/VerticalBarChartData";
import SidebarLink from "../admin/app-sidebar/components/SidebarLink";
import store from "vuex-store";

let palette = store.getters.palette;

export default {
  name: "charts",
  components: {
    SidebarLink
  },
  data: () => ({
    verticalBarChartData: {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      datasets: [
        {
          label: "USA",
          backgroundColor: palette.primary,
          borderColor: palette.transparent,
          data: [50, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        },
        {
          label: "USSR",
          backgroundColor: palette.info,
          borderColor: palette.transparent,
          data: [50, 10, 22, 39, 15, 20, 85, 32, 60, 50, 20, 30]
        }
      ]
    }
  }),
  methods: {
    refreshData() {}
  }
};
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>
